export enum OvertimeStatuses {
  NOT_LOADED_CPRODUCT = 'Не выгружено в 1С',
  LOADED_CPRODUCT = 'Ожидает подтверждения',
  LOADING_ERROR = 'Ошибка выгрузки',
  PROCESS = 'В обработке в 1С',
  APPROVED = 'Проведен в 1С',
  CANCELED = 'Помечен на удаление или отменен в 1С',
}

export enum OvertimeCompensationType {
  HOLIDAY = 'Отгул',
  MONEY = 'Повышенная оплата',
}

export enum OvertimeCompensationTypeBack {
  HOLIDAY = 'holiday',
  MONEY = 'money',
}

export enum OvertimeStatusesBack {
  /**не загружен в 1с */
  NOT_LOADED_CPRODUCT = 'not_loaded',
  /** загружен в 1с и ждет подтверждения  */
  LOADED_CPRODUCT = 'loaded',
  /**в обработке в 1с */
  PROCESS = 'process',
  /** есть ошибка */
  ERROR = 'error',
  /** проведен в 1с */
  APPROVED = 'approved',
  /** помечен на удаление или отменен в 1с */
  CANCELED = 'canceled',
}

export const OVERTIMES_BADGES: Record<
  OvertimeStatusesBack,
  'error' | 'default' | 'success' | 'processing' | 'warning'
> = {
  [OvertimeStatusesBack.NOT_LOADED_CPRODUCT]: 'warning',
  [OvertimeStatusesBack.LOADED_CPRODUCT]: 'success',
  [OvertimeStatusesBack.PROCESS]: 'default',
  [OvertimeStatusesBack.ERROR]: 'error',
  [OvertimeStatusesBack.APPROVED]: 'processing',
  [OvertimeStatusesBack.CANCELED]: 'error',
};

export enum OvertimeCompensationTypeXL {
  HOLIDAY = 'время отдыха',
  MONEY = 'оплата в повышенном размере',
}

export enum ExcelOvertimeCompensationType {
  HOLIDAY = 'время отдыха',
  MONEY = 'оплата в повышенном размере',
}

export const excellOvertimeToWeb = {
  [OvertimeCompensationTypeXL.HOLIDAY]: OvertimeCompensationType.HOLIDAY,
  [OvertimeCompensationTypeXL.MONEY]: OvertimeCompensationType.MONEY,
};

export const webOvertimToExcell = {
  [OvertimeCompensationType.HOLIDAY]: OvertimeCompensationTypeXL.HOLIDAY,
  [OvertimeCompensationType.MONEY]: OvertimeCompensationTypeXL.MONEY,
};

export const overtimeStatusToBack: Record<OvertimeStatuses, OvertimeStatusesBack> = {
  [OvertimeStatuses.LOADED_CPRODUCT]: OvertimeStatusesBack.LOADED_CPRODUCT,
  [OvertimeStatuses.NOT_LOADED_CPRODUCT]: OvertimeStatusesBack.NOT_LOADED_CPRODUCT,
  [OvertimeStatuses.LOADING_ERROR]: OvertimeStatusesBack.ERROR,
  [OvertimeStatuses.PROCESS]: OvertimeStatusesBack.PROCESS,
  [OvertimeStatuses.APPROVED]: OvertimeStatusesBack.APPROVED,
  [OvertimeStatuses.CANCELED]: OvertimeStatusesBack.CANCELED,
};

export const overtimeStatusFromBack: Record<OvertimeStatusesBack, OvertimeStatuses> = {
  [OvertimeStatusesBack.LOADED_CPRODUCT]: OvertimeStatuses.LOADED_CPRODUCT,
  [OvertimeStatusesBack.NOT_LOADED_CPRODUCT]: OvertimeStatuses.NOT_LOADED_CPRODUCT,
  [OvertimeStatusesBack.PROCESS]: OvertimeStatuses.PROCESS,
  [OvertimeStatusesBack.ERROR]: OvertimeStatuses.LOADING_ERROR,
  [OvertimeStatusesBack.APPROVED]: OvertimeStatuses.APPROVED,
  [OvertimeStatusesBack.CANCELED]: OvertimeStatuses.CANCELED,
};

export const overtimeCompensationTypeToBack = {
  [OvertimeCompensationType.HOLIDAY]: OvertimeCompensationTypeBack.HOLIDAY,
  [OvertimeCompensationType.MONEY]: OvertimeCompensationTypeBack.MONEY,
};

export const overtimeCompensationTypeFromBack = {
  [OvertimeCompensationTypeBack.HOLIDAY]: OvertimeCompensationType.HOLIDAY,
  [OvertimeCompensationTypeBack.MONEY]: OvertimeCompensationType.MONEY,
};

export const OvertimeExcellCompensationTypeFromBack = {
  [OvertimeCompensationTypeBack.HOLIDAY]: ExcelOvertimeCompensationType.HOLIDAY,
  [OvertimeCompensationTypeBack.MONEY]: ExcelOvertimeCompensationType.MONEY,
};

export const ExcelOvertimeCompensationTypeToFront = {
  [ExcelOvertimeCompensationType.HOLIDAY]: OvertimeCompensationType.HOLIDAY,
  [ExcelOvertimeCompensationType.MONEY]: OvertimeCompensationType.MONEY,
};

export const OvertimeStatusToBack = {
  [OvertimeStatuses.LOADED_CPRODUCT]: OvertimeStatusesBack.LOADED_CPRODUCT,
  [OvertimeStatuses.NOT_LOADED_CPRODUCT]: OvertimeStatusesBack.NOT_LOADED_CPRODUCT,
};
